import { CheckCircleIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { connect } from "react-redux";
import { Actions as SMART_PENSION_ACTIONS } from "../store/smartPensionActions";
import { Actions as EMPLOYEE_ACTIONS } from "@/redux/actions/employeeActions";
import Spinner from "@/common/Spinner";
import { INTEGRATION_NAME } from "../store/config";
import SchemeErrors from "./SchemeErrors";
import { useEffect } from "react";

const ContributionErrorsModal = ({
	closeModal,
	modalOpen,
	schemes,
	resend,
	saving,
	disabled,
	payPeriodId,
	employeesGetList,
}) => {
	useEffect(() => {
		if (!modalOpen) return;
		employeesGetList();
	}, [modalOpen]);

	if (!modalOpen) return null;
	return (
		<div
			className="modal"
			tabIndex="-1"
			role="dialog"
			aria-hidden="true"
			style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto" }}
		>
			<div
				className="modal-dialog"
				style={{ width: "80%" }}
			>
				<div className="modal-content">
					<div
						className="block block-themed block-transparent remove-margin-b"
						style={{ padding: 0 }}
					>
						<div
							className="block-header bg-primary-dark"
							style={{ padding: 20, position: "sticky", top: 0, zIndex: 50 }}
						>
							<ul className="block-options">
								<li>
									<button
										type="button"
										onClick={closeModal}
									>
										<XMarkIcon className="h-6 w-6 mr-3 text-white" />
									</button>
								</li>
							</ul>
							<h3 className="block-title">{INTEGRATION_NAME} Contributions</h3>
						</div>
						<div className="block-content">
							{schemes?.map((scheme) => (
								<SchemeErrors {...{ scheme }} />
							))}
						</div>
						<div className="col-xs-12 form-container">
							<button
								className="btn btn-success pull-right"
								disabled={saving || disabled}
								onClick={() => {
									if (!saving) resend(payPeriodId);
								}}
							>
								{saving ? (
									<>
										<Spinner
											style={{ width: "1.5rem", height: "1.5rem", marginRight: 5 }}
											className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
										/>
										<div style={{ float: "left" }}>Sending...</div>
									</>
								) : (
									<>
										<CheckCircleIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
										<div style={{ float: "left" }}>Resend</div>
									</>
								)}
							</button>
						</div>
						<div className="clearfix" />
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { payPeriods, errorsModal } = state.integration?.pension?.smartPension || {};
	const payPeriodId = errorsModal;

	const payPeriod = payPeriods?.find((p) => p.payPeriodId == payPeriodId);

	const { details, status } = payPeriod || {};

	const schemes = Object.entries(details || {}).map(([schemeId, scheme]) => {
		return {
			schemeId,
			...scheme,
		};
	});

	return {
		modalOpen: !!errorsModal,
		schemes,
		saving: status === "pending",
		payPeriodId,
		disabled: state?.permissions?.my?.permissions?.payroll == "Read",
	};
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	employeesGetList: () => dispatch(EMPLOYEE_ACTIONS.employeesGetList()),
	closeModal: () => dispatch(SMART_PENSION_ACTIONS.toggleErrorsModal()),
	resend: (periodId) => {
		dispatch(SMART_PENSION_ACTIONS.toggleErrorsModal());
		dispatch(SMART_PENSION_ACTIONS.sendPayPeriodToSmartPension(periodId));
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(ContributionErrorsModal);
